import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@air/primitive-button";
import { DropdownMenu, renderDropdownItems } from "@air/primitive-dropdown-menu";
import { useCopyToWorkspace } from "~/components/CopyToWorkspace/hooks/useCopyToWorkspace";
import { PUBLIC_BOARD_DOWNLOAD_MENU_TRIGGER } from "~/constants/testIDs";
import { useDownloadPublicBoard } from "~/hooks/useDownloadPublicBoard";
import { getDownloadMenuOptions } from "~/utils/menuOptions/getDownloadMenuOptions";
export const PublicBoardDownloadMenu = (param)=>{
    let { board } = param;
    const { downloadPublicBoard } = useDownloadPublicBoard();
    const { copyToAir } = useCopyToWorkspace();
    const menuOptions = getDownloadMenuOptions({
        onDownload: ()=>downloadPublicBoard({
                boardId: board.id,
                trackLocation: "header"
            }),
        onSaveToAir: ()=>copyToAir({
                boardId: board.id,
                trackLocation: "header"
            })
    });
    return /*#__PURE__*/ _jsx(DropdownMenu, {
        trigger: /*#__PURE__*/ _jsx(Button, {
            appearance: "filled",
            color: "blue",
            size: "large",
            className: "ml-3",
            "data-testid": PUBLIC_BOARD_DOWNLOAD_MENU_TRIGGER,
            children: "Save to..."
        }),
        children: renderDropdownItems({
            options: menuOptions
        })
    });
};
